
const newModel = () => {
    return {

        thethaoThanhtichTonghopId: null,
        thethaoGiaithidauId: null,
        tenThethaoGiaithidau: null,
        tenThethaoBomon: null,
        thethaoBomonId: null,
        tenThethaoThanhtich: null,
        thethaoThanhtichId: null,
        soLuong: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,

        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        thethaoThanhtichTonghopId: null,
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoThanhtichId: null,
        soLuong: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

const fromJson = (item) => {
    return {
        thethaoThanhtichTonghopId: item.thethaoThanhtichTonghopId,
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        tenThethaoGiaithidau: item.tenThethaoGiaithidau,
        tenThethaoBomon: item.tenThethaoBomon,
        thethaoBomonId: item.thethaoBomonId,
        tenThethaoThanhtich: item.tenThethaoThanhtich,
        thethaoThanhtichId: item.thethaoThanhtichId,
        soLuong: item.soLuong,
        ghiChu: item.ghiChu,
        stt: item.stt,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoThanhtichTonghopId: item.thethaoThanhtichTonghopId,
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        tenThethaoGiaithidau: item.tenThethaoGiaithidau,
        tenThethaoBomon: item.tenThethaoBomon,
        thethaoBomonId: item.thethaoBomonId,
        tenThethaoThanhtich: item.tenThethaoThanhtich,
        thethaoThanhtichId: item.thethaoThanhtichId,
        soLuong: item.soLuong,
        ghiChu: item.ghiChu,
        stt: item.stt,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const errors = () => {
    return {
        thethaoThanhtichTonghopId: null,
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoThanhtichId: null,
        soLuong: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoThanhtichId: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoThanhtichId: null,
        enabled: null,
    }
}

export const thanhTichTongHopTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
    newPagingSearchModel,
    newSearchModel,
}


